import { render, staticRenderFns } from "./MPopupLayer.vue?vue&type=template&id=2fa9604c&"
import script from "./MPopupLayer.ts?vue&type=script&lang=ts&"
export * from "./MPopupLayer.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports